const Style = {
  footer: "bg-[#07101B] w-full z-50",
  copyright: "text-center text-[7px] text-white md:text-base p-4",
};

export default Style;
